import React, { useEffect, useState } from 'react';
import { Table, Row, Col, message } from 'antd';
import isEmpty from 'lodash/isEmpty';
import orderBy from 'lodash/orderBy';
import { connect } from 'react-redux';
import { fetchRateCard, updateRateCard, resetUpdateRateCard } from 'appRedux/actions/RateCard';
import { fetchRateCardValue, updateRateCardValue, resetUpdateRateCardValue } from 'appRedux/actions/RateCardValue';
import { fetchFreq, updateFreq, resetUpdateFreq } from 'appRedux/actions/Freq';
import { fetchCategory, updateCategory, resetAddCategory } from 'appRedux/actions/Category';
import { fetchIndustry, updateIndustry, resetAddIndustry } from 'appRedux/actions/Industry';
import { fetchPeopleLevelInBrand } from 'appRedux/actions/PeopleLevelInBrand';
import { fetchPeopleLevelInCampaign } from 'appRedux/actions/PeopleLevelInCampaign';
import Widget from 'components/Widget';
import { EditableCell, EditableFormRow } from './EditableCell';
import PeopleLevelInBrandColumns from './PeopleLevelInBrandColumns';
import convertData from 'firebase/utils/convertData';

const DataDefinePriceByReportLevel = ({
  currentUser,
  fetchRateCard,
  fetchRateCardValue,
  fetchFreq,
  updateRateCard,
  updateRateCardValue,
  updateFreq,
  rateCardList,
  rateCardValueList,
  freqList,
  peopleLevelInBrandList,
  peopleLevelInCampaignList,
  loading,
  loadingRateCardValue,
  loadingFreq,
  loadingPeopleLevelInBrand,
  loadingPeopleLevelInCampaign,
  updating,
  updatingRateCardValue,
  updatingFreq,
  payload,
  payloadRateCardValue,
  payloadFreq,
  resetUpdateFreq,
  resetUpdateRateCard,
  resetUpdateRateCardValue,
  industryList,
  categoryList,
  loadingCategory,
  loadingIndustry,
  updatingCategory,
  updatingIndustry,
  payloadCategory,
  payloadIndustry,
  fetchCategory,
  updateCategory,
  resetAddCategory,
  fetchIndustry,
  updateIndustry,
  resetAddIndustry,
  fetchPeopleLevelInBrand,
  fetchPeopleLevelInCampaign,
}) => {
  const [peopleLevelInBrandDataSource, setPeopleLevelInBrandDataSource] = useState([]);
  const [peopleLevelInCampaignDataSource, setPeopleLevelInCampaignDataSource] = useState([]);
  // const [disableSubmit, setDisableSubmit] = useState(false);
  // const [disableSubmitRateCardValue, setDisableSubmitRateCardValue] = useState(false);
  // const [disableSubmitIndustry, setDisableSubmitIndustry] = useState(false);
  // const [disableSubmitPeopleLevelInBrand, setDisableSubmitPeopleLevelInBrand] = useState(false);
  // const [disableSubmitPeopleLevelInCampaign, setDisableSubmitPeopleLevelInCampaign] = useState(false);

  const components = {
    body: {
      row: EditableFormRow,
      cell: EditableCell,
    },
  };

  // const isNotAllowSubmit = loading || loadingRateCardValue || updatingFreq || updatingCategory || updatingIndustry || disableSubmit;

  // const isNotAllowSubmitRateCardValue = loading || loadingRateCardValue || updatingFreq || updatingCategory || updatingIndustry || disableSubmitRateCardValue;

  // const isNotAllowSubmitPeopleLevelInBrand = loading || loadingPeopleLevelInBrand || updatingFreq || updatingCategory || updatingIndustry || disableSubmitPeopleLevelInBrand;

  // const isNotAllowSubmitPeopleLevelInCampaign = loading || loadingPeopleLevelInCampaign || updatingFreq || updatingCategory || updatingIndustry || disableSubmitPeopleLevelInCampaign;



  // const isNotAllowSubmitIndustry = loadingIndustry || updating || updatingRateCardValue || updatingFreq || updatingCategory || disableSubmitIndustry;

  const peopleLevelInBrandColumns = PeopleLevelInBrandColumns().map(col => {
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: record => ({
        record,
        editable: col.editable,
        dataIndex: col.dataIndex,
        title: col.title,
        handleSave: handleUpdateRowPeopleLevelInBrand,
        handleError: handleErrorPeopleLevelInBrand,
      }),
    };
  });

  const peopleLevelInCampaignColumns = PeopleLevelInBrandColumns().map(col => {
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: record => ({
        record,
        editable: col.editable,
        dataIndex: col.dataIndex,
        title: col.title,
        handleSave: handleUpdateRowPeopleLevelInCampaign,
        handleError: handleErrorPeopleLevelInCampaign,
      }),
    };
  });

  const handleUpdateRowPeopleLevelInBrand = row => {
    const newData = [...peopleLevelInBrandDataSource];
    const index = newData.findIndex(item => row.key === item.key);
    const item = newData[index];
    newData.splice(index, 1, {
      ...item,
      ...row,
    });
    setPeopleLevelInBrandDataSource(newData);
  };

  const handleUpdateRowPeopleLevelInCampaign = row => {
    const newData = [...peopleLevelInCampaignDataSource];
    const index = newData.findIndex(item => row.key === item.key);
    const item = newData[index];
    newData.splice(index, 1, {
      ...item,
      ...row,
    });
    setPeopleLevelInCampaignDataSource(newData);
  };

  // const handleSave = e => {
  //   e.preventDefault();
  //   dataSource.forEach((_, i) => { dataSource[i].created_at = moment().unix(); dataSource[i].created_by = currentUser; } );
  //   message.loading({ content: 'Đang cập nhật dữ liệu...', key: 'updatable' });
  //   updateRateCard(dataSource);
  // };

  // const handleSaveRateCardValue = e => {
  //   e.preventDefault();
  //   rateCardValueDataSource.forEach((_, i) => { rateCardValueDataSource[i].created_at = moment().unix(); rateCardValueDataSource[i].created_by = currentUser; } );
  //   message.loading({ content: 'Đang cập nhật dữ liệu...', key: 'updatable' });
  //   updateRateCardValue(rateCardValueDataSource);
  // };

  const handleErrorPeopleLevelInBrand = (isDisabled) => {
    // setDisableSubmitPeopleLevelInBrand(isDisabled);
  };

  const handleErrorPeopleLevelInCampaign = (isDisabled) => {
    // setDisableSubmitPeopleLevelInCampaign(isDisabled);
  };


  // const handleSaveIndustry = e => {
  //   e.preventDefault();
  //   industryDataSource.forEach((_, i) => { industryDataSource[i].created_at = moment().unix(); industryDataSource[i].created_by = currentUser; } );
  //   message.loading({ content: 'Đang cập nhật dữ liệu...', key: 'updatable' });
  //   updateIndustry(industryDataSource);
  // };

  // const handleSavePeopleLevelInBrand = () => {

  // };

  // const handleSavePeopleLevelInCampaign = () => {

  // };

  useEffect(() => {
    fetchPeopleLevelInBrand();
    fetchPeopleLevelInCampaign();
  }, [fetchPeopleLevelInBrand, fetchPeopleLevelInCampaign]);

  useEffect(() => {
    if (payload.message) {
      message.success({ content: payload.message, key: 'updatable', duration: 2  });
      resetUpdateRateCard();
    }
    if (payloadRateCardValue.message) {
      message.success({ content: payloadRateCardValue.message, key: 'updatable', duration: 2  });
      resetUpdateRateCardValue();
    }
    if (payloadFreq.message) {
      message.success({ content: payloadFreq.message, key: 'updatable', duration: 2  });
      resetUpdateFreq();
    }
    if (payloadCategory.message) {
      message.success({ content: payloadCategory.message, key: 'updatable', duration: 2  });
      resetAddCategory();
    }
    if (payloadIndustry.message) {
      message.success({ content: payloadIndustry.message, key: 'updatable', duration: 2  });
      resetAddIndustry();
    }
  }, [payload, payloadRateCardValue, payloadCategory, payloadFreq, payloadIndustry, resetAddCategory, resetAddIndustry, resetUpdateFreq, resetUpdateRateCard, resetUpdateRateCardValue]);

  useEffect(() => {
    if (!loadingPeopleLevelInBrand && !isEmpty(peopleLevelInBrandList)) {
      const convertedData = isEmpty(peopleLevelInBrandList) ? [] : convertData(peopleLevelInBrandList, true);
      const sortedData = orderBy(convertedData, ['task', 'report_level'],['asc', 'asc']);
      setPeopleLevelInBrandDataSource(sortedData);
    }
  }, [loadingPeopleLevelInBrand, peopleLevelInBrandList]);

  useEffect(() => {
    if (!loadingPeopleLevelInCampaign && !isEmpty(peopleLevelInCampaignList)) {
      const convertedData = isEmpty(peopleLevelInCampaignList) ? [] : convertData(peopleLevelInCampaignList, true);
      const sortedData = orderBy(convertedData, ['task', 'report_level'],['asc', 'asc']);
      setPeopleLevelInCampaignDataSource(sortedData);
    }
  }, [loadingPeopleLevelInCampaign, peopleLevelInCampaignList]);

  return (
    <>
      <Row>
        <Col span={24}>
          <Widget
            styleName="gx-order-history"
            title={<h2 className="h4 gx-text-capitalize gx-mb-0">Working hour by report level for brand</h2>}
          >
            <Table
              loading={loadingPeopleLevelInBrand}
              pagination={false}
              bordered
              size='small'
              components={components}
              rowClassName={() => 'editable-row'}
              dataSource={peopleLevelInBrandDataSource}
              columns={peopleLevelInBrandColumns}
            />
            {/* <div className='save-segment'>
              <Button disabled={isNotAllowSubmitPeopleLevelInBrand} loading={updating} icon='vertical-align-bottom' size='large' onClick={handleSavePeopleLevelInBrand} type="primary">
                Save
              </Button>
            </div> */}
          </Widget>
        </Col>
      </Row>

      <Row>
        <Col span={24}>
          <Widget
            styleName="gx-order-history"
            title={<h2 className="h4 gx-text-capitalize gx-mb-0">Working hour by report level for campaign</h2>}
          >
            <Table
              loading={loadingPeopleLevelInCampaign}
              pagination={false}
              bordered
              size='small'
              components={components}
              rowClassName={() => 'editable-row'}
              dataSource={peopleLevelInCampaignDataSource}
              columns={peopleLevelInCampaignColumns}
            />
            {/* <div className='save-segment'>
              <Button disabled={isNotAllowSubmitPeopleLevelInCampaign} loading={updating} icon='vertical-align-bottom' size='large' onClick={handleSavePeopleLevelInCampaign} type="primary">
                Save
              </Button>
            </div> */}
          </Widget>
        </Col>
      </Row>

    </>
  );
}

const mapStateToProps = ({ rateCard, rateCardValue, freq, industry, category, peopleLevelInBrand, peopleLevelInCampaign, auth }) => {
  const { currentUser } = auth;
  const { data: rateCardList, loading, updating, payload } = rateCard;
  const { data: rateCardValueList, loading: loadingRateCardValue, updating: updatingRateCardValue, payload: payloadRateCardValue } = rateCardValue;
  const { data: freqList, loading: loadingFreq, updating: updatingFreq, payload: payloadFreq } = freq;
  const { data: industryList, loading: loadingIndustry, updating: updatingIndustry, payload: payloadIndustry } = industry;
  const { data: categoryList, loading: loadingCategory, updating: updatingCategory, payload: payloadCategory } = category;
  const { data: peopleLevelInBrandList, loading: loadingPeopleLevelInBrand } = peopleLevelInBrand;
  const { data: peopleLevelInCampaignList, loading: loadingPeopleLevelInCampaign } = peopleLevelInCampaign;
  return { currentUser, rateCardList, rateCardValueList, freqList, peopleLevelInBrandList, loadingPeopleLevelInBrand, peopleLevelInCampaignList, loadingPeopleLevelInCampaign, loading, loadingRateCardValue, loadingFreq, updating, updatingRateCardValue, updatingFreq, payload, payloadRateCardValue, payloadFreq, industryList, categoryList, loadingCategory, loadingIndustry, updatingCategory, updatingIndustry, payloadCategory, payloadIndustry };
};

export default connect(
  mapStateToProps,
  {
    fetchRateCard,
    updateRateCard,
    fetchRateCardValue,
    updateRateCardValue,
    fetchFreq,
    updateFreq,
    resetUpdateRateCard,
    resetUpdateRateCardValue,
    resetUpdateFreq,
    fetchCategory,
    updateCategory,
    resetAddCategory,
    fetchIndustry,
    updateIndustry,
    resetAddIndustry,
    fetchPeopleLevelInBrand,
    fetchPeopleLevelInCampaign,
  },
)(DataDefinePriceByReportLevel);
